import FirstGradient from "../Gradients/FirstGradient";
import SecondGradient from "../Gradients/SecondGradient";
import * as S from "./style";

const capabilities = [
  { text: "Use pre-built AI agents" },
  { text: "Build your own agents" },
  { text: "Order custom-made agents" },
  { text: "Connect agents into Automated Workflows" },
  { text: "Discuss your challenges with industry experts" },
  { text: "Automate processes of any complexity", bold: true },
];

function FirstSection() {
  const gotoUpstrima = () => {
    window.open("https://upstrima.ai", "_blank");
  };

  return (
    <S.FirstSection>
      <S.BlackOverlay>
        <S.OilDerrick
          width="42"
          height="63"
          viewBox="0 0 42 63"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_317_1870)">
            <path
              d="M40.7342 61.7591H1.26579V57.731H4.8483H4.84917C4.85004 57.731 4.8509 57.731 4.8509 57.731H37.1169C37.1169 57.731 37.1178 57.731 37.1186 57.731C37.1186 57.731 37.1195 57.731 37.1204 57.731H40.7342V61.7591ZM13.2608 2.97232C13.2608 2.01929 14.0534 1.24479 15.0286 1.24479H27.048C28.0223 1.24479 28.8157 2.01929 28.8157 2.97232C28.8157 3.92534 28.0223 4.69984 27.048 4.69984H25.7648H21.3228C21.2375 4.65733 21.1409 4.63098 21.0383 4.63098C20.9348 4.63098 20.8391 4.65733 20.7529 4.69984H16.1561H15.0286C14.0534 4.69984 13.2608 3.92534 13.2608 2.97232ZM21.8656 10.282L25.3994 6.60249L27.4656 16.0299L21.8656 10.282ZM21.6707 50.7793L34.2547 56.494H21.6707V50.7793ZM8.21331 44.6666L19.495 49.7914L5.73218 56.0299L8.21331 44.6666ZM10.945 32.1523L19.6603 36.7619L8.66569 42.5948L10.945 32.1523ZM13.7445 19.3302L19.9421 23.7604L11.4652 29.7685L13.7445 19.3302ZM20.1239 10.2879L14.4222 16.2254L16.5249 6.59399L20.1239 10.2879ZM20.4049 8.7823L17.6324 5.93682H20.4049V8.7823ZM21.6707 17.6486V11.876L27.295 17.6486H21.6707ZM22.0927 23.7646L28.2111 19.428L30.4756 29.7583L22.0927 23.7646ZM22.3171 36.7602L31.0002 32.1532L33.2812 42.5583L22.3171 36.7602ZM33.7493 44.693L36.2339 56.0282L22.5016 49.7923L33.7493 44.693ZM20.4049 44.398V48.8401L10.624 44.398H20.4049ZM20.4049 43.161H10.2525L20.4049 37.7744V43.161ZM20.4049 31.8335V35.7493L13.0016 31.8335H20.4049ZM20.4049 30.5965H12.4526L20.4049 24.9608V30.5965ZM21.6707 18.8856H26.8209L21.6707 22.5353V18.8856ZM28.9497 31.8335L21.6707 35.6958V31.8335H28.9497ZM21.6707 30.5965V24.9965L29.5047 30.5965H21.6707ZM31.3917 44.398L21.6707 48.8044V44.398H31.3917ZM21.6707 43.161V37.8254L31.7606 43.161H21.6707ZM14.7911 17.6486L20.4049 11.8029V17.6486H14.7911ZM20.4049 18.8856V22.5591L15.2661 18.8856H20.4049ZM24.3032 5.93682L21.6707 8.67773V5.93682H24.3032ZM7.71743 56.494L20.4049 50.7419V56.494H7.71743ZM41.3667 56.494H37.6302L34.8741 43.9211C34.8768 43.9109 34.8794 43.9015 34.8811 43.8913C34.8837 43.8794 34.8846 43.8683 34.8863 43.8581C34.8881 43.8403 34.8889 43.8233 34.8898 43.8071C34.8907 43.7969 34.8924 43.7884 34.8924 43.7791C34.8924 43.7757 34.8924 43.7731 34.8915 43.7706C34.8915 43.7595 34.8907 43.7485 34.8898 43.7383C34.8889 43.7204 34.8863 43.7034 34.8837 43.6864C34.8811 43.6728 34.8802 43.6592 34.8776 43.6465C34.875 43.6371 34.8724 43.6286 34.8698 43.6192C34.8654 43.6031 34.8602 43.5878 34.8541 43.5725C34.8489 43.558 34.8446 43.5427 34.8376 43.5283C34.8359 43.5249 34.8359 43.5223 34.8341 43.5189C34.8324 43.5147 34.8289 43.5104 34.8263 43.5062C34.8193 43.4917 34.8106 43.479 34.8028 43.4645C34.7932 43.4509 34.7863 43.4365 34.7758 43.4229C34.7706 43.4161 34.7663 43.4093 34.7602 43.4025L32.0624 31.0922C32.0624 31.0913 32.0616 31.0896 32.0616 31.0888L29.3186 18.5761C29.3238 18.5668 29.3273 18.5566 29.3325 18.5464C29.3377 18.5362 29.3438 18.5277 29.349 18.5183C29.3499 18.5158 29.3516 18.5141 29.3525 18.5115C29.3551 18.5056 29.3568 18.4988 29.3595 18.4928C29.3673 18.4741 29.3716 18.4537 29.3777 18.4342C29.3829 18.4154 29.389 18.3976 29.3925 18.378C29.3969 18.3551 29.3977 18.3313 29.3995 18.3092C29.4003 18.3032 29.4012 18.299 29.4012 18.2939C29.4012 18.2879 29.403 18.2828 29.403 18.2769C29.403 18.2735 29.4038 18.2701 29.4038 18.2667C29.4038 18.2633 29.403 18.2607 29.403 18.2573C29.403 18.2327 29.3986 18.2089 29.396 18.1842C29.3934 18.1681 29.3925 18.151 29.389 18.1357C29.3847 18.1153 29.3769 18.0958 29.3708 18.0762C29.369 18.072 29.3673 18.0669 29.3655 18.0626C29.3638 18.055 29.3621 18.049 29.3595 18.0422C29.356 18.0346 29.3542 18.0269 29.3508 18.0193C29.3438 18.004 29.3342 17.9895 29.3255 17.9742C29.3142 17.953 29.3029 17.9317 29.289 17.913C29.2864 17.9096 29.2855 17.9062 29.2838 17.9037C29.2751 17.8918 29.2638 17.8832 29.2551 17.8722C29.2481 17.8637 29.242 17.856 29.2351 17.8484C29.2324 17.8467 29.2316 17.8433 29.2298 17.8407L29.1359 17.7447L26.5477 5.93682H27.048C28.72 5.93682 30.0815 4.60632 30.0815 2.97232C30.0815 1.33831 28.72 0.0078125 27.048 0.0078125H25.235H16.9416H15.0286C13.3556 0.0078125 11.995 1.33831 11.995 2.97232C11.995 4.60632 13.3556 5.93682 15.0286 5.93682H15.374L12.7136 18.1238C12.7136 18.1247 12.7136 18.1255 12.7136 18.1264L12.7101 18.1391C12.7101 18.1408 12.7093 18.1425 12.7093 18.1451L9.88363 31.0888C9.88276 31.0896 9.88276 31.0913 9.88276 31.0922L7.14412 43.6363C7.14412 43.6371 7.14412 43.6371 7.14325 43.638L7.14064 43.6524C7.13977 43.6541 7.13977 43.655 7.13977 43.6567L4.33676 56.494H0.632462C0.282737 56.494 0 56.7704 0 57.1121V62.3772C0 62.7198 0.282737 62.9961 0.632462 62.9961H41.3667C41.7164 62.9961 42 62.7198 42 62.3772V57.1121C42 56.7704 41.7164 56.494 41.3667 56.494Z"
              fill="#F9F6EF"
            />
          </g>
          <defs>
            <clipPath id="clip0_317_1870">
              <rect width="42" height="63" fill="white" />
            </clipPath>
          </defs>
        </S.OilDerrick>
        <S.OilDerrickLineContainer>
          <S.OilDerrickLine
            xmlns="http://www.w3.org/2000/svg"
            width="1540"
            height="24"
            viewBox="0 0 1540 24"
            fill="none"
          >
            <path
              d="M1540 23L1048.47 23L1027.01 1H512.986L491.528 23H0"
              stroke="#F9F6EF"
              strokeWidth="1.5"
            />
          </S.OilDerrickLine>
        </S.OilDerrickLineContainer>
        <S.OilDerrickLineMob
          xmlns="http://www.w3.org/2000/svg"
          width="345"
          height="10"
          viewBox="0 0 345 10"
          fill="none"
        >
          <path d="M345.001 9H56.2632L48.4605 1H0" stroke="#F9F6EF" />
        </S.OilDerrickLineMob>
        <S.StartDrillingsInscription>
          start drilling
        </S.StartDrillingsInscription>
        <S.ArrowDrillings
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="27"
          viewBox="0 0 18 27"
          fill="none"
        >
          <path d="M9 0L9 26" stroke="#F9F6EF" strokeWidth="1.5" />
          <path d="M17 19L9 26L1 19" stroke="#F9F6EF" strokeWidth="1.5" />
        </S.ArrowDrillings>
      </S.BlackOverlay>
      <S.Content>
        <FirstGradient />
        <SecondGradient />
        <S.ContentHeader as="h1">
          Oil and Gas Engineering. Accelerated by AI.
        </S.ContentHeader>
        <S.ContentSubHeader>
          Marketplace of High-Impact AI Agents, Automated Workflows, Intelligent
          Tools, and Human Expertise – All in One Workspace
        </S.ContentSubHeader>
        <S.BottomContent>
          <S.ContentLeft>
            <S.ContentLogo
              width="386"
              height="117"
              viewBox="0 0 386 117"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              fetchpriority="high"
            >
              <path
                d="M213.736 83.6486H207.664V56.2047L198.867 83.6486H190.598L181.8 56.2047V83.6486H175.728V50.3906H185.816L194.757 78.5775L203.649 50.3906H213.736V83.6486ZM240.431 70.8573L234.695 55.0887L229.007 70.8573H240.431ZM242.344 76.1129H227.094L224.369 83.6486H217.819L230.631 50.3906H238.855L251.619 83.6486H245.07L242.344 76.1129ZM0 77.9284V50.3906H6.12097V76.9497C6.12097 77.4166 6.21562 77.7407 6.40801 77.9284C6.59809 78.1138 6.91591 78.2068 7.36456 78.2068H20.8447C21.2903 78.2068 21.6089 78.1138 21.8012 77.9284C21.9913 77.7407 22.0875 77.4166 22.0875 76.9497V50.3906H28.2062V77.9284C28.2062 79.5082 27.696 80.8568 26.6771 81.975C25.6582 83.091 24.1753 83.6486 22.2314 83.6486H5.97784C4.03396 83.6486 2.55105 83.091 1.52986 81.975C0.510979 80.8568 0 79.5082 0 77.9284ZM54.1799 66.7168C54.6255 66.7168 54.9433 66.6253 55.1357 66.4376C55.3258 66.2522 55.422 65.9281 55.422 65.462V57.1353C55.422 56.641 55.3258 56.2985 55.1357 56.1131C54.9433 55.9255 54.5939 55.8347 54.0829 55.8347H39.7424V66.7168H54.1799ZM33.6215 50.3906H55.2296C57.2704 50.3906 58.831 50.9482 59.9153 52.0665C60.9989 53.1825 61.5406 54.5311 61.5406 56.1131V66.4376C61.5406 68.0196 61.0304 69.3683 60.0115 70.4842C58.9926 71.6025 57.5097 72.1601 55.5659 72.1601H39.7424V83.6486H33.6215V50.3906ZM67.5377 78.2068H86.0368C86.5478 78.2068 86.8972 78.1138 87.0895 77.9284C87.2796 77.7407 87.3766 77.4005 87.3766 76.904V70.7177C87.3766 69.8176 86.931 69.3683 86.0368 69.3683H72.3166C70.3727 69.3683 68.8898 68.8107 67.8709 67.6955C66.852 66.5772 66.341 65.2286 66.341 63.6488V56.1131C66.341 54.5311 66.8836 53.1825 67.9671 52.0665C69.0514 50.9482 70.6128 50.3906 72.6529 50.3906H92.1085V55.8347H73.7995C72.9053 55.8347 72.4597 56.268 72.4597 57.1353V62.7182C72.4597 63.182 72.5567 63.5092 72.7467 63.6946C72.9399 63.8792 73.2577 63.9738 73.7033 63.9738H87.2796C89.2558 63.9738 90.7849 64.5314 91.8692 65.6466C92.9535 66.7648 93.4952 68.1135 93.4952 69.6955V77.9284C93.4952 79.541 92.9766 80.8972 91.9423 81.9979C90.905 83.0979 89.3674 83.6486 87.3266 83.6486H67.5377V78.2068ZM109.353 55.8347H98.595V50.3906H126.229V55.8347H115.471V83.6486H109.353V55.8347ZM153.204 57.1353C153.204 56.641 153.107 56.2985 152.917 56.1131C152.726 55.9255 152.375 55.8347 151.864 55.8347H137.523V65.4162H151.961C152.406 65.4162 152.726 65.3224 152.917 65.137C153.107 64.9494 153.204 64.6252 153.204 64.1584V57.1353ZM153.347 70.8573H152.343L159.228 83.6486H152.486L145.698 70.8573H137.523V83.6486H131.499V50.3906H153.013C155.051 50.3906 156.614 50.9482 157.696 52.0665C158.78 53.1825 159.322 54.5311 159.322 56.1131V65.137C159.322 66.7168 158.814 68.0654 157.792 69.1837C156.773 70.2997 155.291 70.8573 153.347 70.8573ZM164.057 50.3906H170.177V83.6486H164.057V50.3906Z"
                fill="#F9F6EF"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M335.616 0C295.458 126.716 247.207 105.294 263.148 16.752H285.232C227.958 156.284 333.651 149.4 386.001 0H335.616Z"
                fill="url(#paint0_linear_317_419)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_317_419"
                  x1="260.023"
                  y1="116.907"
                  x2="260.023"
                  y2="0"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#00AAFF" />
                  <stop offset="0.5" stopColor="#1DD59F" />
                  <stop offset="1" stopColor="#39FF3F" />
                </linearGradient>
              </defs>
            </S.ContentLogo>
            <S.Button onClick={gotoUpstrima}>Start</S.Button>
          </S.ContentLeft>
          <S.ContentRight>
            <S.ContentRightHeader as="h2">
              Transform Your Engineering
              <br />
              Workflows with Industry-Specific AI,
              <br />
              Guided by Real Engineers
            </S.ContentRightHeader>
            <S.ContentRightList>
              {capabilities.map(({ text, bold }) => (
                <S.ContentRightListItem
                  key={text}
                  style={bold ? { fontWeight: 700 } : undefined}
                >
                  {text}
                </S.ContentRightListItem>
              ))}
            </S.ContentRightList>
            <S.Arrow
              xmlns="http://www.w3.org/2000/svg"
              width="12"
              height="17"
              viewBox="0 0 12 17"
              fill="none"
            >
              <path
                d="M12 8.5L2.17658e-07 5.2958e-07L9.53674e-07 17L12 8.5Z"
                fill="#31ED37"
              />
            </S.Arrow>
          </S.ContentRight>
        </S.BottomContent>
      </S.Content>
    </S.FirstSection>
  );
}

export default FirstSection;
